import {
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    UPDATE_SETTINGS_QUESTION_ANSWERS,
    UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS,
    CHANGE_FEEDBACK,
    CHANGE_FEEDBACK_SUCCESS,

} from './constants.js';

/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getSettings = id => ({
    type: GET_SETTINGS,
    id
});
/**
 *
 * @param settings
 * @returns {{settings: *, type: string}}
 */
const getSettignsSuccess = settings => ({
    type: GET_SETTINGS_SUCCESS,
    settings
});
/**
 *
 * @param id
 * @param value
 * @returns {{id: *, type: string, value: *}}
 */
const updateSettingsQuestionAnswers = (id, value) => ({
    type: UPDATE_SETTINGS_QUESTION_ANSWERS,
    id,
    value
});
/**
 *
 * @param id
 * @param value
 * @returns {{id: *, type: string, value: *}}
 */
const updateSettingsQuestionAnswersSuccess = (id, value) => ({
    type: UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS,
    id,
    value
});
/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
const changeFeedback = (value) => ({
  type: CHANGE_FEEDBACK,
  value
});
/**
 *
 * @param value
 * @returns {{type: string, value: *}}
 */
const changeFeedbackSuccess = (value) => ({
  type: CHANGE_FEEDBACK_SUCCESS,
  value
});

export {
    getSettings,
    getSettignsSuccess,
    updateSettingsQuestionAnswers,
    updateSettingsQuestionAnswersSuccess,
    changeFeedback,
    changeFeedbackSuccess
};